var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search-02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.5 31.5L37.125 37.125",
    stroke: "white",
    strokeWidth: 3.375,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M36.9749 41.6816C35.675 40.3818 35.675 38.2745 36.9749 36.9749C38.2745 35.675 40.3818 35.675 41.6816 36.9749L48.525 43.8182C49.8248 45.1181 49.8248 47.2254 48.525 48.525C47.2254 49.8248 45.1181 49.8248 43.8182 48.525L36.9749 41.6816Z",
    stroke: "white",
    strokeWidth: 3.375,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M36 20.25C36 11.5515 28.9485 4.5 20.25 4.5C11.5515 4.5 4.5 11.5515 4.5 20.25C4.5 28.9485 11.5515 36 20.25 36C28.9485 36 36 28.9485 36 20.25Z",
    stroke: "white",
    strokeWidth: 3.375,
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.0cf3eeba9dc5eea1592fb00b0de00b60.svg";
export { ForwardRef as ReactComponent };